// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"cbf08e32","2030":"cbf08e32","2061":"697b17c2","5469":"6c477c18","6548":"cbf08e32","6785":"cbf08e32","8976":"a607c02b"}[chunkId] + ".chunk.css";
};